import LazyLoad from 'vanilla-lazyload';

(function () {
  const $els = document.querySelectorAll('[data-vanilla="news-lazy"]');

  if (!$els.length) {
    return;
  }

  new LazyLoad({
    container: $els[0],
    delay: 5,
    elements_selector: '.lazy'
  });
})();
